import type { InboxMacro } from '@sbc/domain-models/gateway';

const PLACEHOLDER = /\{\{[^{}]*\}\}/g;
const FIRST_NAME = /\{\{\s*first_name\s*(?:\|[^{}]*)?\}\}/g;
const GREETING = /^(hi|hello|hey|dear)\b/i;

export function searchMacros(macros: readonly InboxMacro[], query: string): InboxMacro[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return [...macros];
  }
  return macros
    .flatMap((macro) => {
      const name = macro.name.toLowerCase();
      const body = macro.body.toLowerCase();
      if (!words.every((word) => name.includes(word) || body.includes(word))) {
        return [];
      }
      return [{ macro, nameHits: words.filter((word) => name.includes(word)).length }];
    })
    .toSorted((a, b) => b.nameHits - a.nameHits)
    .map(({ macro }) => macro);
}

export function fillMacro(body: string, firstName: string | null): string {
  return firstName ? body.replace(FIRST_NAME, () => firstName) : body;
}

export function unfilledPlaceholders(text: string): string[] {
  return [...new Set(text.match(PLACEHOLDER))];
}

export function firstNameOf(name: string | null | undefined): string | null {
  return name?.trim().split(/\s+/)[0] || null;
}

export function macroPreview(body: string): string {
  return (
    body
      .split('\n')
      .map((line) => line.trim())
      .find((line) => line.length > 0 && !GREETING.test(line)) ?? ''
  );
}

export function insertMacro(
  text: string,
  macroText: string,
  selectionStart: number,
  selectionEnd: number,
): { text: string; cursor: number } {
  const before = text.slice(0, selectionStart);
  const after = text.slice(selectionEnd);
  const lead = before.length > 0 && !/\s$/.test(before) ? '\n\n' : '';
  const trail = after.length > 0 && !/^\s/.test(after) ? '\n\n' : '';
  const inserted = `${lead}${macroText}${trail}`;
  return {
    text: `${before}${inserted}${after}`,
    cursor: before.length + lead.length + macroText.length,
  };
}
